import { CreateSupportReq, DeleteSupportReq, MetadataForQuery, UpdateSupportReq } from '../../../shared/dto/ReqDtoRepository';
import { SupportListResponse, SupportResponse, DeleteResponse } from '../../../shared/dto/ResDtoRepository';
import { useTempAlertStore } from '../../../shared/store/portal/tempAlertStore';
import { useApiWrapper } from '../../../shared/hooks/useApi/apiWrapper';
import { getSupport, getSupportList, deleteSupport, updateSupport } from '../api/adminApi';
import { SupportData } from '../../../shared/dto/EntityRepository';
import { useAdminSupportListStore, useAdminSupportViewStore } from '../store/adminSupportStore';
import { usePageStore } from '../../../shared/store/pageStore';


interface UseSupportResult {
  activeSupport: SupportData | null;
  setActiveSupport: (support: SupportData | null) => void;
  supportList: SupportData[];
  getSupport: (aui: string) => Promise<void>;
  getSupportList: (aui: string, metaData: MetadataForQuery) => Promise<void>;
  updateSupport: (aui: string, data: UpdateSupportReq) => Promise<void>;
  deleteSupport: (aui: string, data: DeleteSupportReq) => Promise<void>;
}

export const useAdminSupport = (): UseSupportResult => {
  const { activeSupport, setActiveSupport, afterDeleteActiveSupport } = useAdminSupportViewStore();
  const { setUpdatedTempAlert, setDeletedTempAlert } = useTempAlertStore();
  const { supportList, setSupportList, sortData, pageSize } = useAdminSupportListStore();
  const { setPage } = usePageStore();
  const withApiHandler = useApiWrapper();

  const handleGetSupportSuccess = (response: SupportResponse) => {
    const supportData = response.data;
    setActiveSupport(supportData);
  };

  const handleGetSupportListSuccess = (response: SupportListResponse) => {
    const data = response.data;
    setPage(data);
    setSupportList(data.content);
  };

  const handleUpdateSupportSuccess = (response: SupportResponse) => {
    const data = response.data;
    const newSupportList = supportList.map((each) => each.id === data.id ? data : each);
    setUpdatedTempAlert();
    setActiveSupport(data);
    setSupportList(newSupportList);
  };

  const handleDeleteSupportSuccess = (response: DeleteResponse) => {
    console.log("deleted well");
    afterDeleteActiveSupport();
    setDeletedTempAlert();
  };

  const handleSupportRequest = async (
    aui: string,
    action: 'get' | 'get_list' | 'update' | 'delete',
    data?: CreateSupportReq | UpdateSupportReq | DeleteSupportReq,
    metaData?: MetadataForQuery
  ) => {
    const apiFunction = async () => {
      switch (action) {
        case 'update':
          handleUpdateSupportSuccess(await updateSupport(aui, data as UpdateSupportReq));
          break;
        case 'delete':
          handleDeleteSupportSuccess(await deleteSupport(aui, data as DeleteSupportReq));
          getSupportListHandler(aui, { page: 1, size: pageSize, sortData: sortData, filterData: {} });
          break;
        case 'get':
          handleGetSupportSuccess(await getSupport(aui));
          break;
        case 'get_list':
        default:
          handleGetSupportListSuccess(await getSupportList(aui, metaData!));
          break;
      }
    };

    await withApiHandler(apiFunction, [aui, action, data]);
  };

  const getSupportHandler = (aui: string) => handleSupportRequest(aui, 'get');
  const getSupportListHandler = (aui: string, metaData: MetadataForQuery) => handleSupportRequest(aui, 'get_list', undefined, metaData);
  const updateSupportHandler = (aui: string, data: UpdateSupportReq) => handleSupportRequest(aui, 'update', data);
  const deleteSupportHandler = (aui: string, data: DeleteSupportReq) => handleSupportRequest(aui, 'delete', data);

  return {
    activeSupport,
    setActiveSupport,
    supportList,
    getSupport: getSupportHandler,
    getSupportList: getSupportListHandler,
    updateSupport: updateSupportHandler,
    deleteSupport: deleteSupportHandler,
  };
};